// modules
const company = "company"
const saloon = "saloon"
const web = "web"
const marketing = "marketing"
const customer = "customer"
const calendar = "calendar"
const financeReport = "financeReport"
const program = "program"
const organizationsAndLessons = "organizationsAndLessons"

export const dashboardPagesMenu = {
	dashboard: {
		id: "dashboard",
		text: "main",
		path: "/",
		icon: "Dashboard",
		subMenu: null,
	},
};

export const companyPageMenues = {
	com: {
		id: company,
		text: company,
		icon: "Extension",
	},
	company: {
		id: company,
		text: company,
		path: "company/details",
		icon: "HomeWork",
		block: ["companyDetail", "corporate", "traveler"],
		subMenu: {
			companyDetail: {
				id: "companyDetail",
				text: "companyDetail",
				path: "company/details",
				icon: "HomeWork",
				master: [company, company],
			},
			corporate: {
				id: "corporate",
				text: "corporate",
				path: "company/corporate",
				icon: "Business",
				master: [company, company],
			},
			traveler: {
				id: "traveler",
				text: "traveler",
				path: "company/traveler",
				icon: "Hiking",
				master: [company, company],
			},
		},
	},
	users: {
		id: "users",
		text: "users",
		path: "company/users",
		icon: "PersonAddAlt",
	},
	payments: {
		id: "payments",
		text: "payments",
		path: "company/payments",
		icon: "CreditCard",
	},
};

export const saloonPageMenues = {
	com: {
		id: saloon,
		text: saloon,
		icon: "HomeWork",
		block: ["barLoads", "banners", "aggreements", "barBalance", "saloonDetail", "gates", "saloonGeneralInfo", "saloonGallery", "saloonCertificates", "gates", "places", "envantory", "cleaning", "saloonBar", "barSales", "barProducts",],
	},
	saloonDetail: {
		id: "saloonDetail",
		text: "saloonDetail",
		path: "saloon/detaıl",
		icon: "HomeWork",
		block: ["saloonGeneralInfo", "saloonGallery"],
		master: [saloon],
		subMenu: {
			saloonGeneralInfo: {
				id: "saloonGeneralInfo",
				text: "saloonGeneralInfo",
				path: "saloon/general-info",
				icon: "InfoOutline",
				master: [saloon, "saloonDetail"],
			},
			saloonGallery: {
				id: "saloonGallery",
				text: "saloonGallery",
				path: "saloon/gallery",
				icon: "AddPhotoAlternate",
				master: [saloon, "saloonDetail"],
			},
			saloonCertificates: {
				id: "saloonCertificates",
				text: "saloonCertificates",
				path: "saloon/certificates",
				icon: "Approval",
				master: [saloon, "saloonDetail"],
			},
		}
	},
	aggreements: {
		id: "aggreements",
		text: "aggreements",
		path: "saloon/aggreements",
		icon: "Cases",
		master: [saloon],
		block: []
	},
	banners: {
		id: "banners",
		text: "banners",
		path: "saloon/banners",
		icon: "Image",
		master: [saloon],
		block: []
	},
	gates: {
		id: "gates",
		text: "gates",
		path: "saloon/gates-statistic",
		icon: "MultipleStop",
		master: [saloon],
		block: []
	},
	places: {
		id: "places",
		text: "places",
		path: "saloon/places",
		icon: "DoorFront",
		master: [saloon],
		block: []
	},
	saloonBar: {
		id: "saloonBar",
		text: "saloonBar",
		path: "saloon/detaıl",
		icon: "FoodBank",
		block: ["barLoads", "barBalance", "barSales", "barProducts"],
		master: [saloon],
		subMenu: {
			barLoads: {
				id: "barLoads",
				text: "barLoads",
				path: "saloon/bar-loads",
				icon: "CreditCard",
				master: [saloon, "saloonBar"],
			},
			barBalance: {
				id: "barBalance",
				text: "barBalance",
				path: "saloon/bar-balance",
				icon: "People",
				master: [saloon, "saloonBar"],
			},
			barSales: {
				id: "barSales",
				text: "barSales",
				path: "saloon/bar-sales",
				icon: "Money",
				master: [saloon, "saloonBar"],
			},
			barProducts: {
				id: "barProducts",
				text: "barProducts",
				path: "saloon/bar-products",
				icon: "Fastfood",
				master: [saloon, "saloonBar"],
			}
		}
	},


	// envantory: {
	// 	id: "envantory",
	// 	text: "envantory",
	// 	path: "saloon/envantory",
	// 	icon: "BackupTable",
	// 	master: [saloon],
	// 	block: []
	// },
	// cleaning: {
	// 	id: "cleaning",
	// 	text: "cleaning",
	// 	path: "saloon/cleaning",
	// 	icon: "CleaningServices",
	// 	master: [saloon],
	// 	block: []

	// },
};

export const webPageMenues = {
	webPages: {
		id: web,
		text: web,
		icon: "Extension",
		block: ["webPage", "subscriptions", "events", "blog"],
	},
	web: {
		id: "webPage",
		text: "webPage",
		path: "web/web",
		icon: "Web",
		block: ["subscriptions", "events", "blog"],
		master: [web],
		subMenu: {
			subscriptions: {
				id: "wsubscriptions",
				text: "wsubscriptions",
				path: "web/subscriptions",
				icon: "AttachMoney",
				master: [web, "webPage"],
			},
			events: {
				id: "events",
				text: "events",
				path: "web/events",
				icon: "Event",
				master: [web, "webPage"],
			},
			blog: {
				id: "blog",
				text: "blog",
				path: "web/blog",
				icon: "Article",
				master: [web, "webPage"],
			},
		}
	},
}

export const marketingPageMenues = {
	marketing: {
		id: marketing,
		text: marketing,
		icon: "Extension",
		block: ["allForms","forms", "marketingSales", "contactBase", "staffBase", "marketingStats", "contactBaseStats", "staffBaseStats", "callLists","contactReports"]
	},
	allForms: {
		id: "allForms",
		text: "allForms",
		icon: "Badge",
		path: "/marketing/all-forms",
		master: [marketing],
	},
	forms: {
		id: "forms",
		text: "forms",
		icon: "Badge",
		path: "/marketing/forms",
		master: [marketing],
	},
	callLists: {
		id: "callLists",
		text: "callLists",
		icon: "PhoneInTalk",
		path: "/marketing/call-lists",
		master: [marketing],
	},
	contactReports: {
		id: "contactReports",
		text: "contactReports",
		icon: "Report",
		path: "/marketing/contact-reports",
		master: [marketing],
	},
	marketingSales: {
		id: "marketingSales",
		text: "marketingSales",
		icon: "CheckCircleOutline",
		path: "/marketing/stats",
		master: [marketing],
		block: ["contactBase", "staffBase"],
		subMenu: {
			contactBase: {
				id: "contactBase",
				text: "contactBase",
				icon: "People",
				path: "/marketing/contact-base",
				master: [marketing, "marketingSales"],
			},
			staffBase: {
				id: "staffBase",
				text: "staffBase",
				icon: "PersonPin",
				path: "/marketing/staff-base",
				master: [marketing, "marketingSales"],
			}
		}
	},
	marketingStats: {
		id: "marketingStats",
		text: "marketingStats",
		icon: "BarChart",
		path: "/marketing/stats",
		master: [marketing],
		block: ["contactBaseStats", "staffBaseStats"],
		subMenu: {
			contactBaseStats: {
				id: "contactBaseStats",
				text: "contactBaseStats",
				icon: "People",
				path: "/marketing/contact-base-stats",
				master: [marketing, "marketingStats"],
			},
			staffBaseStats: {
				id: "staffBaseStats",
				text: "staffBaseStats",
				icon: "PersonPin",
				path: "/marketing/staff-base-stats",
				master: [marketing, "marketingStats"],
			}
		}
	},
};

export const customerPageMenues = {
	customer: {
		id: customer,
		text: customer,
		icon: "Extension",
		block: ["messages", "subscriptions", "customerNotifications", "customers", "customerPrograms", "activeCustomers", "passiveCustomers", "customerWorkouts", "customerNutritions", "customerEvents", "activeReport"],
	},
	messages: {
		id: "messages",
		text: "messages",
		icon: "Message",
		path: "/customer/messages",
		master: [customer],
		block: [],
	},
	subscriptions: {
		id: "subscriptions",
		text: "subscriptions",
		icon: "PermContactCalendar",
		path: "/customer/subscriptions",
		master: [customer],
		block: [],
	},
	customers: {
		id: "customers",
		text: "customers",
		icon: "PeopleAlt",
		path: "/customer/customers",
		master: [customer],
	},
	activeReport: {
		id: "activeReport",
		text: "activeReport",
		icon: "Assessment",
		path: "/customer/active-report",
		master: [customer],
	},
	customerNotifications: {
		id: "customerNotifications",
		text: "customerNotifications",
		icon: "Notifications",
		path: "/customer/customer-notifications",
		master: [customer],
		block: [],
	},
	offers: {
		id: "offers",
		text: "offers",
		icon: "LocalOffer",
		path: "/customer/offers",
		master: [customer],
		block: [],
	},
	customerPrograms: {
		id: "customerPrograms",
		text: "customerPrograms",
		icon: "PeopleAlt",
		path: "/customer/list",
		master: [customer],
		block: ["customerWorkouts", "customerNutritions", "customerEvents"],
		subMenu: {
			customerEvents: {
				id: "customerEvents",
				text: "customerEvents",
				icon: "PersonPin",
				path: "/customer/workout-events",
				master: [customer, "customerPrograms"],
			},
			customerWorkouts: {
				id: "customerWorkouts",
				text: "customerWorkouts",
				icon: "DirectionsRun",
				path: "/customer/workout-customers",
				master: [customer, "customerPrograms"],
			},
			customerNutritions: {
				id: "customerNutritions",
				text: "customerNutritions",
				icon: "Fastfood",
				path: "/customer/nutrition-customers",
				master: [customer, "customerPrograms"],
			},
		}
	},

};

export const programMenues = {
	program: {
		id: program,
		text: program,
		icon: "Dashboard",
		subMenu: null,
		block: ["workout", "movements", "workouts", "food", "foods", "recipes", "nutrition", "sets", "nutritionPrograms"],
	},
	workout: {
		id: "workout",
		text: "workout",
		path: "page-layouts",
		icon: "PlaylistAddCheck",
		master: [program],
		block: ["movements", "workouts"],
		subMenu: {
			movements: {
				id: "movements",
				text: "movements",
				path: "programs/movements",
				icon: "DirectionsRun",
				master: [program, "workout"],
			},
			workouts: {
				id: "workouts",
				text: "workouts",
				path: "program/workouts",
				icon: "PlaylistAddCheck",
				master: [program, "workout"],
			},
		},
	},
	foods: {
		id: "food",
		text: "food",
		path: "page-layouts",
		icon: "FoodBank",
		master: [program],
		block: ["foods", "recipes"],
		subMenu: {
			foods: {
				id: "foods",
				text: "foods",
				path: "programs/foods",
				icon: "FoodBank",
				master: [program, "food"],
			},
			recipes: {
				id: "recipes",
				text: "recipes",
				path: "program/recipes",
				icon: "SetMeal",
				master: [program, "food"],
			},
		},
	},
	nutrition: {
		id: "nutrition",
		text: "nutrition",
		path: "page-layouts",
		icon: "DinnerDining",
		master: [program],
		block: ["sets", "nutritionPrograms"],
		subMenu: {
			sets: {
				id: "sets",
				text: "sets",
				path: "programs/nutrition-sets",
				icon: "TableView",
				master: [program, "nutrition"],
			},
			nutritionPrograms: {
				id: "nutritionPrograms",
				text: "nutritionPrograms",
				path: "program/nutrition-programs",
				icon: "PivotTableChart",
				master: [program, "nutrition"],
			},
		},
	},
};

export const calendarPageMenues = {
	company: {
		id: calendar,
		text: calendar,
		icon: "Dashboard",
		subMenu: null,
	},
	allEvents: {
		id: "allEvents",
		text: "allEvents",
		icon: "EventNote",
		master: [calendar],
		block: [],
		path: "/calendar/all-events",
	},
	periodicEvents: {
		id: "periodicEvents",
		text: "periodicEvents",
		icon: "CalendarViewWeek",
		master: [calendar],
		block: [],
		path: "/calendar/periodic-events",
	},
	myEvents: {
		id: "myEvents",
		text: "myEvents",
		icon: "EventNote",
		master: [calendar],
		block: [],
		path: "/calendar/my-events",
	},
	calendarList: {
		id: "calendarList",
		text: "calendarList",
		icon: "EditCalendar",
		master: [calendar],
		block: [],
		path: "/calendar/reservations",
	},
	calendarSettings: {
		id: "calendarSettings",
		text: "calendarSettings",
		icon: "Settings",
		path: "/calendar/calendar-settings",
		master: [calendar],
		block: [],
	},
};

export const financeReportPageMenues = {
	financeReport: {
		id: financeReport,
		text: financeReport,
		icon: "AttachMoney",
		block: ["accounts", "transactions", "accounts2", "installments", "monthlyBalance", "general", "income", "outcome", "specialReports", "staffPortions"]
	},
	accounts: {
		id: "accounts",
		text: "accounts",
		icon: "AccountBalanceWallet",
		path: "/finance-report/stats",
		master: [financeReport],
		block: ["transactions", "accounts2", "installments"],
		subMenu: {
			transactions: {
				id: "transactions",
				text: "transactions",
				icon: "AttachMoney",
				path: "/finance-report/transactions",
				master: [financeReport, "accounts"],
			},
			installments: {
				id: "installments",
				text: "installments",
				icon: "PendingActions",
				path: "/finance-report/installments",
				master: [financeReport, "accounts"],
			},
			accounts: {
				id: "accounts2",
				text: "accounts2",
				icon: "AccountBalanceWallet",
				path: "/finance-report/accounts",
				master: [financeReport, "accounts"],
			}
		}
	},
	monthlyBalance: {
		id: "monthlyBalance",
		text: "monthlyBalance",
		icon: "EditCalendar",
		path: "/finance-report/stats",
		master: [financeReport],
		block: ["general", "income", "outcome"],
		subMenu: {
			general: {
				id: "general",
				text: "general",
				icon: "Analytics",
				path: "/finance-report/general",
				master: [financeReport, "monthlyBalance"],
			},
			income: {
				id: "income",
				text: "income",
				icon: "ArrowCircleDown",
				path: "/finance-report/income",
				master: [financeReport, "monthlyBalance"],
			},
			outcome: {
				id: "outcome",
				text: "outcome",
				icon: "ArrowCircleUp",
				path: "/finance-report/outcome",
				master: [financeReport, "monthlyBalance"],
			},
		}
	},
	specialReports: {
		id: "specialReports",
		text: "specialReports",
		icon: "RequestPage",
		path: "/finance-report/stats",
		master: [financeReport],
		block: ["staffPortions", "cafeBarReport", "productSalesReport", "packagesReport", "travelerReport", "corporatePackageReport"],
		subMenu: {
			staffPortions: {
				id: "staffPortions",
				text: "staffPortions",
				icon: "People",
				path: "/finance-report/staff-portions",
				master: [financeReport, "specialReports"],
			},
			dailyreport: {
				id: "dailyreport",
				text: "dailyreport",
				icon: "Today",
				path: "/finance-report/daily-report",
				master: [financeReport, "specialReports"],
			},
			cafeBarReport: {
				id: "cafeBarReport",
				text: "cafeBarReport",
				icon: "LocalCafe",
				path: "/finance-report/cafe-bar",
				master: [financeReport, "specialReports"],
			},
			productSalesReport: {
				id: "productSalesReport",
				text: "productSalesReport",
				icon: "Storefront",
				path: "/finance-report/product-sales",
				master: [financeReport, "specialReports"],
			},
			packagesReport: {
				id: "packagesReport",
				text: "packagesReport",
				icon: "Inventory",
				path: "/finance-report/packages",
				master: [financeReport, "specialReports"],
			},
			travelerReport: {
				id: "travelerReport",
				text: "travelerReport",
				icon: "Hiking",
				path: "/finance-report/traveler",
				master: [financeReport, "specialReports"],
			},
			corporatePackageReport: {
				id: "corporatePackageReport",
				text: "corporatePackageReport",
				icon: "Business",
				path: "/finance-report/corporate-packages",
				master: [financeReport, "specialReports"],
			},
		}
	},
};

export const myPages = {
	department: {
		id: "departman",
		text: "department",
		path: "/dashboard/departments",
		icon: "Dashboard",
		isPublic: true
	},
	projects: {
		id: "proje",
		text: "projects",
		path: "/dashboard/projects",
		icon: "Workspaces",
		isPublic: true
	},
	production: {
		id: "production",
		text: "production",
		path: "/dashboard/production",
		icon: "Verified",
		isPublic: true
	},
	tasks: {
		id: "tasks",
		text: "tasks",
		path: "/dashboard/tasks",
		icon: "Task",
		isPublic: true
	},
};

export const demoPagesMenu = {
	auth: {
		id: "auth",
		text: "Auth Pages",
		icon: "Extension",
	},
	login: {
		id: "login",
		text: "login",
		path: "auth/login",
		icon: "Login",
	},
	signUp: {
		id: "signUp",
		text: "signUp",
		path: "auth/sign-up",
		icon: "PersonAdd",
	},
	page404: {
		id: "Page404",
		text: "404",
		path: "auth/404",
		icon: "ReportGmailerrorred",
	},
};

export const pageLayoutTypesPagesMenu = {
	layoutTypes: {
		id: "layoutTypes",
		text: "Page Layout Types",
	},
	blank: {
		id: "blank",
		text: "Blank",
		path: "page-layouts/blank",
		icon: "check_box_outline_blank ",
	},
	pageLayout: {
		id: "pageLayout",
		text: "Page Layout",
		path: "page-layouts",
		icon: "BackupTable",
		subMenu: {
			headerAndSubheader: {
				id: "headerAndSubheader",
				text: "Header & Subheader",
				path: "page-layouts/header-and-subheader",
				icon: "ViewAgenda",
			},
			onlyHeader: {
				id: "onlyHeader",
				text: "Only Header",
				path: "page-layouts/only-header",
				icon: "ViewStream",
			},
			onlySubheader: {
				id: "onlySubheader",
				text: "Only Subheader",
				path: "page-layouts/only-subheader",
				icon: "ViewStream",
			},
			onlyContent: {
				id: "onlyContent",
				text: "Only Content",
				path: "page-layouts/only-content",
				icon: "WebAsset",
			},
		},
	},
	asideTypes: {
		id: "asideTypes",
		text: "Aside Types",
		path: "aside-types",
		icon: "Vertical Split",
		subMenu: {
			defaultAside: {
				id: "defaultAside",
				text: "Default Aside",
				path: "aside-types/default-aside",
				icon: "ViewQuilt",
			},
			minimizeAside: {
				id: "minimizeAside",
				text: "Minimize Aside",
				path: "aside-types/minimize-aside",
				icon: "View Compact",
			},
		},
	},
};

export const summaryPageTopMenu = {
	intro: { id: "intro", text: "Intro", path: "#intro", icon: "Vrpano", subMenu: null },
	bootstrap: {
		id: "bootstrap",
		text: "Bootstrap Components",
		path: "#bootstrap",
		icon: "BootstrapFill",
		subMenu: null,
	},
	storybook: {
		id: "storybook",
		text: "Storybook",
		path: "#storybook",
		icon: "CustomStorybook",
		subMenu: null,
	},
	formik: {
		id: "formik",
		text: "Formik",
		path: "#formik",
		icon: "CheckBox",
		subMenu: null,
	},
	apex: {
		id: "apex",
		text: "Apex Charts",
		path: "#apex",
		icon: "AreaChart",
		subMenu: null,
	},
};

export const organizationsAndLessonsPageMenues = {
	organizationsAndLessons: {
		id: organizationsAndLessons,
		text: "organizationsAndLessons",
		icon: "Extension",
		block: ["organizations", "lessons","topics","lessonsList", "records","lessonRecords"],
	},
	organizations: {
		id: "organizations",
		text: "organizations",
		icon: "Campaign",
		path: "/organizations-and-lessons/organizations",
		master: [organizationsAndLessons],
		block: [],
	},
	lessons: {
		id: "lessons",
		text: "lessons",
		icon: "School",
		path: "page-layouts",
		master: [organizationsAndLessons],
		block: ["lessonsList", "topics"],
		subMenu: {
			lessonsList: {
				id: "lessonsList",
				text: "lessonsList",
				icon: "MenuBook",
				path: "/organizations-and-lessons/lessons",
				master: [organizationsAndLessons, "lessons"],
			},
			topics: {
				id: "topics",
				text: "topics",
				icon: "Topic",
				path: "/organizations-and-lessons/topics",
				master: [organizationsAndLessons, "lessons"],
			},
		},
	},
	records: {
		id: "records",
		text: "records",
		icon: "Assignment",
		path: "/organizations-and-lessons/lesson-records",
		master: [organizationsAndLessons],
		block: [],
	},
};

export const productsExampleMenu = {
	companyA: { id: "companyA", text: "Company A", path: "grid-pages/products", subMenu: null },
	companyB: { id: "companyB", text: "Company B", path: "/", subMenu: null },
	companyC: { id: "companyC", text: "Company C", path: "/", subMenu: null },
	companyD: { id: "companyD", text: "Company D", path: "/", subMenu: null },
};
